import * as React from 'react';
import { createRoot } from 'react-dom/client';

import { Application } from '../../../shared/common/containers/App';
import { IApplicationContext } from '../../../shared/common/types/applicationContext';
import { TReduxStore } from '../../../shared/common/types/redux';

interface IDependencies {
  store: TReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;

  const projectName = context.config.getStrict<string>('projectName');

  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  const page = createRoot(rootElement);

  page.render(<Application context={context} reduxStore={store} />);
}
